import AdminLayout from '@/layouts/AdminLayout.vue'

const Pages = () => import('@/pages/admin/pages/Pages.vue')

const Tests = () => import('@/pages/admin/tests/Tests.vue')
const Testlist = () => import('@/pages/admin/tests/Testlist.vue')
const Testquestions = () => import('@/pages/admin/tests/Testquestions.vue')

const Dictresults = () => import('@/pages/admin/dictresults/Dictresults.vue')

const Settings = () => import('@/pages/admin/settings/Settings.vue')

export default {
    path: '/admin',
    redirect:'/admin/cabinet',
    component: AdminLayout,
    children: [
        {
            path: 'cabinet',
            name: 'Кабинет'
        },
        {
            path: 'pages',
            name: 'Страницы',
            component: Pages
        },
        {
            path: 'tests',
            component: Tests,
            children: [
                {
                    path: '',
                    name: 'Тесты',
                    component: Testlist
                },
                {
                    path: ':id',
                    name: 'Задания теста',
                    component: Testquestions
                }
            ]
        },
        {
            path: 'dictresults',
            name: 'Результаты диктанта(админ)',
            component: Dictresults
        },
        {
            path: 'settings',
            name: 'Глобальные настройки',
            component: Settings
        }
    ]
}